var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BeeModel } from "./BeeModel";
import keyBy from "lodash/keyBy";
import values from "lodash/values";
var cache = new WeakMap();
var BeeModelManager = /** @class */ (function () {
    function BeeModelManager(modelTypes, entities, options) {
        if (options === void 0) { options = {}; }
        this.modelTypes = modelTypes;
        this.entities = entities;
        this.options = options;
        this.recordsMap = new Map();
    }
    Object.defineProperty(BeeModelManager.prototype, "ModelClass", {
        get: function () {
            return BeeModel;
        },
        enumerable: false,
        configurable: true
    });
    BeeModelManager.prototype.createModelManager = function (entities, options) {
        if (options === void 0) { options = {}; }
        return new BeeModelManager(this.modelTypes, entities, __assign(__assign({}, this.options), options));
    };
    BeeModelManager.prototype.getRawRecords = function (modelType) {
        var _a;
        var entities = (this.entities || {})[modelType];
        if (entities && cache.has(entities))
            return cache.get(entities);
        var records = values((_a = (this.entities || {})[modelType]) !== null && _a !== void 0 ? _a : []);
        entities && cache.set(entities, records);
        return cache.get(entities);
    };
    BeeModelManager.prototype.getRecordsMap = function (modelType) {
        if (!this.recordsMap.has(modelType))
            this.recordsMap.set(modelType, keyBy(this.getRawRecords(modelType), "attributes.id"));
        return this.recordsMap.get(modelType) || {};
    };
    BeeModelManager.prototype.getCollection = function (modelType) {
        var records = this.getRawRecords(modelType);
        return this.constructCollection(records, modelType);
    };
    BeeModelManager.prototype.constructCollection = function (records, modelType) {
        var _this = this;
        if (records === void 0) { records = []; }
        if (!Array.isArray(records)) {
            records = values(records);
        }
        var ModelClass = this.getModelClass(modelType);
        var CollectionClass = this.getModelCollectionClass(modelType);
        var models = records.map(function (item) { return new ModelClass(_this, item); });
        return new CollectionClass(ModelClass, this, models, this.options);
    };
    BeeModelManager.prototype.hasEntity = function (modelType) {
        return !!this.getRawRecords(modelType);
    };
    BeeModelManager.prototype.getModelClass = function (modelType) {
        return this.modelTypes[modelType] || this.ModelClass;
    };
    BeeModelManager.prototype.getModelCollectionClass = function (modelType) {
        return this.getModelClass(modelType).getCollectionClass();
    };
    return BeeModelManager;
}());
export { BeeModelManager };
